import { TemplateElement, html, toString, defineElement, i18n } from '@webtides/element-js';
import CurrencyFormatter from '../../../../js/helper/currency-formatter';
import style from './shopping-cart.css';
import '../cart-item/cart-item.js';
import '../../../elements/discount-code/discount-code';

export default class ShoppingCart extends TemplateElement {
    constructor() {
        super({ shadowRender: true, styles: [style] });
    }

    properties() {
        return {
            items: [],
            withDiscountCode: false,
            withSummary: true,
            withDiscount: true,
            editable: true,
            cart: {},
        };
    }

    templateDiscountControls() {
        return html`
            <div class="mb-8 border-b border-grey-200 pb-8">
                <discount-code ref="discount" .cart="${this.cart}"></discount-code>
            </div>
        `;
    }

    templatePrice() {
        if (this.cart?.discounted) {
            return html`
                <div class="line-through decoration-2 decoration-status-red text-xl">
                    ${CurrencyFormatter.formattedPrice(this.cart?.totalPrice + this.cart?.totalPriceDiscount)}
                </div>
                <div class="text-status-red">${CurrencyFormatter.formattedPrice(this.cart?.totalPrice)}</div>
            `;
        }
        return `${CurrencyFormatter.formattedPrice(this.cart?.totalPrice)}`;
    }
    template() {
        return html`
            <slot name="header">
                <div class="py-2 md:py-4 font-extrabold text-lg uppercase">${i18n('checkout.shoppingCart.items')}</div>
            </slot>
            <div class="mb-8 border-t-2 border-black">
                ${this.items.map(item => {
                    return html` <cart-item .item="${item}" editable="${this.editable}"></cart-item> `;
                })}
            </div>
            ${this.withDiscount ? this.templateDiscountControls() : null}
            ${this.withSummary
                ? html`
                      <div class="row no-gutters items-center">
                          <div class="col w-full md:w-1/2">
                              <div class="font-extrabold text-lg">${i18n('checkout.shoppingCart.sum')}</div>
                              <div class="font-light text-grey-700 text-sm">
                                  ${i18n('checkout.shoppingCart.deliveryChargesNotice')}
                              </div>
                          </div>
                          <div class="col w-full md:w-1/2">
                              <div refs="totalPrice" class="font-extrabold text-black text-xl md:text-2xl text-right">
                                  ${this.templatePrice()}
                              </div>
                          </div>
                      </div>
                  `
                : html``}
        `;
    }
}

defineElement('shopping-cart', ShoppingCart);
